/** @jsx jsx */
import { jsx, css } from '@emotion/core';

import { gridSize } from '@atlaskit/theme/constants';
import { N20, N800, R500 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

import PropsLayoutRenderer from './props-table';

/**
 * This gets imported in two places:
 *   1. Top-level component pages
 *   2. Sub-level component pages
 *
 * By having a wrapper we can have a single source of truth for both locations.
 */

const Props = (props) => {
  return (
    <div
      css={css`
        margin-top: ${gridSize() * 3}px;
        margin-bottom: ${gridSize() * 6}px;

        :last-child {
          margin-bottom: 0;
        }

        h3 > code:last-of-type {
          /* Styles the 'required' prop text. Should be removed as soon as pretty-proptypes supports custom colours / tokens:
          https://product-fabric.atlassian.net/browse/DSP-3249 */
          color: ${token('color.text.danger', R500)};
        }

        h3 > code:first-of-type {
          /* Styles the prop name heading */
          background-color: ${token('color.background.neutral', N20)};
          color: ${token('color.text', N800)};
        }
      `}
    >
      <PropsLayoutRenderer {...props} />
    </div>
  );
};

export default Props;
